export default "__VITE_ASSET__A8Y_MTSU__"